import React, { Component } from 'react';
import axios from 'axios';
import { graphql, gql as gqlM } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import gql from 'graphql-tag';

import GlobVar from '../../../GlobalVar';
import Title from '../common/Title';
import Label from '../common/Label';
import TextArea from '../common/TextArea';
import Select from '../common/Select';
import SearchInstitution from './SearchInstitution';
import Validator from '../common/Validator';
import Button from '../common/Button';
import Help from '../../general/Help';

/**
 * This component creates the page that defines the partners, such as the institutions names,
 * the institutions Erasmus codes, the contacts names, emails, phones and websites, and much 
 * more information.
 * Updates are made by the parent, storing the data in localStorage "partnersDetails" and 
 * calling back the refreshPage function passed as prop from IIACreation.
 */
class Partner extends Component {
    constructor(props) {
        super(props);

        this.state = {
            key: "",
            isPartnerInEWPSearch: false,
            partnerStaticData: null,
            partnerEWPStatus: -2,
            partnerEWPIIA: 0,
            partnerEWPInst: 0,
            partnerEWPOU: 0,
            searchOpen: false,
            statusPopUp: false,
            searchValue: "",
            searchKey: "",
            academicYearsStartSelectionIndex: 0,
            creatorInstitution: props.data.creatorInstitution,
            creatorErasmusCode: props.data.creatorErasmusCode,
            creatorCountry: props.data.creatorCountry,
            creatorCity: props.data.creatorCity,
            creatorContactName: props.data.creatorContactName,
            creatorContactEmail: props.data.creatorContactEmail,
            creatorContactPhone: props.data.creatorContactPhone,
            creatorGeneralWebsite: props.data.creatorGeneralWebsite,
            creatorFacultyWebsite: props.data.creatorFacultyWebsite,
            creatorCourseWebsite: props.data.creatorCourseWebsite,
            creatorSigningDate: props.data.creatorSigningDate,
            creatorOUnit: props.data.creatorOUnit,
            creatorOUlist: [],
            iiaCode: props.data.iiaCode,
            useFactsheetData: props.data.useFactsheetData,
            partnerInstsAvailable: props.data.partnerErasmusCode.split(" ").join(""),
            partnerErasmusCode: props.data.partnerErasmusCode,
            partnerInstitution: props.data.partnerInstitution,
            partnerCountry: props.data.partnerCountry,
            partnerCity: props.data.partnerCity,
            partnerContactName: props.data.partnerContactName,
            partnerContactEmail: props.data.partnerContactEmail,
            partnerContactPhone: props.data.partnerContactPhone,
            partnerGeneralWebsite: props.data.partnerGeneralWebsite,
            partnerFacultyWebsite: props.data.partnerFacultyWebsite,
            partnerCourseWebsite: props.data.partnerCourseWebsite,
            partnerOUnit: props.data.partnerOUnit,
            partnerOUlist: [],
            academicYearStart: props.data.academicYearStart,
            academicYearEnd: props.data.academicYearEnd,
            instList: [],
            iiaFetched: 0,
            mtPlusPIC: "",
            searchingMT: 0,
            searchingMTError: false,
            getPDWasClickedAtLeastOnce: JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation")).getPDWasClickedAtLeastOnce,
            isErasmusCodeValid: JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation")).partnerErasmusCodeValid,
            countryList: [{ "Code": "AF", "Name": "Afghanistan" }, { "Code": "AX", "Name": "\u00c5land Islands" }, { "Code": "AL", "Name": "Albania" }, { "Code": "DZ", "Name": "Algeria" }, { "Code": "AS", "Name": "American Samoa" }, { "Code": "AD", "Name": "Andorra" }, { "Code": "AO", "Name": "Angola" }, { "Code": "AI", "Name": "Anguilla" }, { "Code": "AQ", "Name": "Antarctica" }, { "Code": "AG", "Name": "Antigua and Barbuda" }, { "Code": "AR", "Name": "Argentina" }, { "Code": "AM", "Name": "Armenia" }, { "Code": "AW", "Name": "Aruba" }, { "Code": "AU", "Name": "Australia" }, { "Code": "AT", "Name": "Austria" }, { "Code": "AZ", "Name": "Azerbaijan" }, { "Code": "BS", "Name": "Bahamas" }, { "Code": "BH", "Name": "Bahrain" }, { "Code": "BD", "Name": "Bangladesh" }, { "Code": "BB", "Name": "Barbados" }, { "Code": "BY", "Name": "Belarus" }, { "Code": "BE", "Name": "Belgium" }, { "Code": "BZ", "Name": "Belize" }, { "Code": "BJ", "Name": "Benin" }, { "Code": "BM", "Name": "Bermuda" }, { "Code": "BT", "Name": "Bhutan" }, { "Code": "BO", "Name": "Bolivia, Plurinational State of" }, { "Code": "BQ", "Name": "Bonaire, Sint Eustatius and Saba" }, { "Code": "BA", "Name": "Bosnia and Herzegovina" }, { "Code": "BW", "Name": "Botswana" }, { "Code": "BV", "Name": "Bouvet Island" }, { "Code": "BR", "Name": "Brazil" }, { "Code": "IO", "Name": "British Indian Ocean Territory" }, { "Code": "BN", "Name": "Brunei Darussalam" }, { "Code": "BG", "Name": "Bulgaria" }, { "Code": "BF", "Name": "Burkina Faso" }, { "Code": "BI", "Name": "Burundi" }, { "Code": "KH", "Name": "Cambodia" }, { "Code": "CM", "Name": "Cameroon" }, { "Code": "CA", "Name": "Canada" }, { "Code": "CV", "Name": "Cape Verde" }, { "Code": "KY", "Name": "Cayman Islands" }, { "Code": "CF", "Name": "Central African Republic" }, { "Code": "TD", "Name": "Chad" }, { "Code": "CL", "Name": "Chile" }, { "Code": "CN", "Name": "China" }, { "Code": "CX", "Name": "Christmas Island" }, { "Code": "CC", "Name": "Cocos (Keeling) Islands" }, { "Code": "CO", "Name": "Colombia" }, { "Code": "KM", "Name": "Comoros" }, { "Code": "CG", "Name": "Congo" }, { "Code": "CD", "Name": "Congo, the Democratic Republic of the" }, { "Code": "CK", "Name": "Cook Islands" }, { "Code": "CR", "Name": "Costa Rica" }, { "Code": "CI", "Name": "C\u00f4te d'Ivoire" }, { "Code": "HR", "Name": "Croatia" }, { "Code": "CU", "Name": "Cuba" }, { "Code": "CW", "Name": "Cura\u00e7ao" }, { "Code": "CY", "Name": "Cyprus" }, { "Code": "CZ", "Name": "Czech Republic" }, { "Code": "DK", "Name": "Denmark" }, { "Code": "DJ", "Name": "Djibouti" }, { "Code": "DM", "Name": "Dominica" }, { "Code": "DO", "Name": "Dominican Republic" }, { "Code": "EC", "Name": "Ecuador" }, { "Code": "EG", "Name": "Egypt" }, { "Code": "SV", "Name": "El Salvador" }, { "Code": "GQ", "Name": "Equatorial Guinea" }, { "Code": "ER", "Name": "Eritrea" }, { "Code": "EE", "Name": "Estonia" }, { "Code": "ET", "Name": "Ethiopia" }, { "Code": "FK", "Name": "Falkland Islands (Malvinas)" }, { "Code": "FO", "Name": "Faroe Islands" }, { "Code": "FJ", "Name": "Fiji" }, { "Code": "FI", "Name": "Finland" }, { "Code": "FR", "Name": "France" }, { "Code": "GF", "Name": "French Guiana" }, { "Code": "PF", "Name": "French Polynesia" }, { "Code": "TF", "Name": "French Southern Territories" }, { "Code": "GA", "Name": "Gabon" }, { "Code": "GM", "Name": "Gambia" }, { "Code": "GE", "Name": "Georgia" }, { "Code": "DE", "Name": "Germany" }, { "Code": "GH", "Name": "Ghana" }, { "Code": "GI", "Name": "Gibraltar" }, { "Code": "GR", "Name": "Greece" }, { "Code": "GL", "Name": "Greenland" }, { "Code": "GD", "Name": "Grenada" }, { "Code": "GP", "Name": "Guadeloupe" }, { "Code": "GU", "Name": "Guam" }, { "Code": "GT", "Name": "Guatemala" }, { "Code": "GG", "Name": "Guernsey" }, { "Code": "GN", "Name": "Guinea" }, { "Code": "GW", "Name": "Guinea-Bissau" }, { "Code": "GY", "Name": "Guyana" }, { "Code": "HT", "Name": "Haiti" }, { "Code": "HM", "Name": "Heard Island and McDonald Islands" }, { "Code": "VA", "Name": "Holy See (Vatican City State)" }, { "Code": "HN", "Name": "Honduras" }, { "Code": "HK", "Name": "Hong Kong" }, { "Code": "HU", "Name": "Hungary" }, { "Code": "IS", "Name": "Iceland" }, { "Code": "IN", "Name": "India" }, { "Code": "ID", "Name": "Indonesia" }, { "Code": "IR", "Name": "Iran, Islamic Republic of" }, { "Code": "IQ", "Name": "Iraq" }, { "Code": "IE", "Name": "Ireland" }, { "Code": "IM", "Name": "Isle of Man" }, { "Code": "IL", "Name": "Israel" }, { "Code": "IT", "Name": "Italy" }, { "Code": "JM", "Name": "Jamaica" }, { "Code": "JP", "Name": "Japan" }, { "Code": "JE", "Name": "Jersey" }, { "Code": "JO", "Name": "Jordan" }, { "Code": "KZ", "Name": "Kazakhstan" }, { "Code": "KE", "Name": "Kenya" }, { "Code": "KI", "Name": "Kiribati" }, { "Code": "KP", "Name": "Korea, Democratic People's Republic of" }, { "Code": "KR", "Name": "Korea, Republic of" }, { "Code": "KW", "Name": "Kuwait" }, { "Code": "KG", "Name": "Kyrgyzstan" }, { "Code": "LA", "Name": "Lao People's Democratic Republic" }, { "Code": "LV", "Name": "Latvia" }, { "Code": "LB", "Name": "Lebanon" }, { "Code": "LS", "Name": "Lesotho" }, { "Code": "LR", "Name": "Liberia" }, { "Code": "LY", "Name": "Libya" }, { "Code": "LI", "Name": "Liechtenstein" }, { "Code": "LT", "Name": "Lithuania" }, { "Code": "LU", "Name": "Luxembourg" }, { "Code": "MO", "Name": "Macao" }, { "Code": "MK", "Name": "Macedonia, the Former Yugoslav Republic of" }, { "Code": "MG", "Name": "Madagascar" }, { "Code": "MW", "Name": "Malawi" }, { "Code": "MY", "Name": "Malaysia" }, { "Code": "MV", "Name": "Maldives" }, { "Code": "ML", "Name": "Mali" }, { "Code": "MT", "Name": "Malta" }, { "Code": "MH", "Name": "Marshall Islands" }, { "Code": "MQ", "Name": "Martinique" }, { "Code": "MR", "Name": "Mauritania" }, { "Code": "MU", "Name": "Mauritius" }, { "Code": "YT", "Name": "Mayotte" }, { "Code": "MX", "Name": "Mexico" }, { "Code": "FM", "Name": "Micronesia, Federated States of" }, { "Code": "MD", "Name": "Moldova, Republic of" }, { "Code": "MC", "Name": "Monaco" }, { "Code": "MN", "Name": "Mongolia" }, { "Code": "ME", "Name": "Montenegro" }, { "Code": "MS", "Name": "Montserrat" }, { "Code": "MA", "Name": "Morocco" }, { "Code": "MZ", "Name": "Mozambique" }, { "Code": "MM", "Name": "Myanmar" }, { "Code": "NA", "Name": "Namibia" }, { "Code": "NR", "Name": "Nauru" }, { "Code": "NP", "Name": "Nepal" }, { "Code": "NL", "Name": "Netherlands" }, { "Code": "NC", "Name": "New Caledonia" }, { "Code": "NZ", "Name": "New Zealand" }, { "Code": "NI", "Name": "Nicaragua" }, { "Code": "NE", "Name": "Niger" }, { "Code": "NG", "Name": "Nigeria" }, { "Code": "NU", "Name": "Niue" }, { "Code": "NF", "Name": "Norfolk Island" }, { "Code": "MP", "Name": "Northern Mariana Islands" }, { "Code": "NO", "Name": "Norway" }, { "Code": "OM", "Name": "Oman" }, { "Code": "PK", "Name": "Pakistan" }, { "Code": "PW", "Name": "Palau" }, { "Code": "PS", "Name": "Palestine, State of" }, { "Code": "PA", "Name": "Panama" }, { "Code": "PG", "Name": "Papua New Guinea" }, { "Code": "PY", "Name": "Paraguay" }, { "Code": "PE", "Name": "Peru" }, { "Code": "PH", "Name": "Philippines" }, { "Code": "PN", "Name": "Pitcairn" }, { "Code": "PL", "Name": "Poland" }, { "Code": "PT", "Name": "Portugal" }, { "Code": "PR", "Name": "Puerto Rico" }, { "Code": "QA", "Name": "Qatar" }, { "Code": "RE", "Name": "R\u00e9union" }, { "Code": "RO", "Name": "Romania" }, { "Code": "RU", "Name": "Russian Federation" }, { "Code": "RW", "Name": "Rwanda" }, { "Code": "BL", "Name": "Saint Barth\u00e9lemy" }, { "Code": "SH", "Name": "Saint Helena, Ascension and Tristan da Cunha" }, { "Code": "KN", "Name": "Saint Kitts and Nevis" }, { "Code": "LC", "Name": "Saint Lucia" }, { "Code": "MF", "Name": "Saint Martin (French part)" }, { "Code": "PM", "Name": "Saint Pierre and Miquelon" }, { "Code": "VC", "Name": "Saint Vincent and the Grenadines" }, { "Code": "WS", "Name": "Samoa" }, { "Code": "SM", "Name": "San Marino" }, { "Code": "ST", "Name": "Sao Tome and Principe" }, { "Code": "SA", "Name": "Saudi Arabia" }, { "Code": "SN", "Name": "Senegal" }, { "Code": "RS", "Name": "Serbia" }, { "Code": "SC", "Name": "Seychelles" }, { "Code": "SL", "Name": "Sierra Leone" }, { "Code": "SG", "Name": "Singapore" }, { "Code": "SX", "Name": "Sint Maarten (Dutch part)" }, { "Code": "SK", "Name": "Slovakia" }, { "Code": "SI", "Name": "Slovenia" }, { "Code": "SB", "Name": "Solomon Islands" }, { "Code": "SO", "Name": "Somalia" }, { "Code": "ZA", "Name": "South Africa" }, { "Code": "GS", "Name": "South Georgia and the South Sandwich Islands" }, { "Code": "SS", "Name": "South Sudan" }, { "Code": "ES", "Name": "Spain" }, { "Code": "LK", "Name": "Sri Lanka" }, { "Code": "SD", "Name": "Sudan" }, { "Code": "SR", "Name": "Suriname" }, { "Code": "SJ", "Name": "Svalbard and Jan Mayen" }, { "Code": "SZ", "Name": "Swaziland" }, { "Code": "SE", "Name": "Sweden" }, { "Code": "CH", "Name": "Switzerland" }, { "Code": "SY", "Name": "Syrian Arab Republic" }, { "Code": "TW", "Name": "Taiwan, Province of China" }, { "Code": "TJ", "Name": "Tajikistan" }, { "Code": "TZ", "Name": "Tanzania, United Republic of" }, { "Code": "TH", "Name": "Thailand" }, { "Code": "TL", "Name": "Timor-Leste" }, { "Code": "TG", "Name": "Togo" }, { "Code": "TK", "Name": "Tokelau" }, { "Code": "TO", "Name": "Tonga" }, { "Code": "TT", "Name": "Trinidad and Tobago" }, { "Code": "TN", "Name": "Tunisia" }, { "Code": "TR", "Name": "Turkey" }, { "Code": "TM", "Name": "Turkmenistan" }, { "Code": "TC", "Name": "Turks and Caicos Islands" }, { "Code": "TV", "Name": "Tuvalu" }, { "Code": "UG", "Name": "Uganda" }, { "Code": "UA", "Name": "Ukraine" }, { "Code": "AE", "Name": "United Arab Emirates" }, { "Code": "GB", "Name": "United Kingdom" }, { "Code": "US", "Name": "United States" }, { "Code": "UM", "Name": "United States Minor Outlying Islands" }, { "Code": "UY", "Name": "Uruguay" }, { "Code": "UZ", "Name": "Uzbekistan" }, { "Code": "VU", "Name": "Vanuatu" }, { "Code": "VE", "Name": "Venezuela, Bolivarian Republic of" }, { "Code": "VN", "Name": "Viet Nam" }, { "Code": "VG", "Name": "Virgin Islands, British" }, { "Code": "VI", "Name": "Virgin Islands, U.S." }, { "Code": "WF", "Name": "Wallis and Futuna" }, { "Code": "EH", "Name": "Western Sahara" }, { "Code": "YE", "Name": "Yemen" }, { "Code": "ZM", "Name": "Zambia" }, { "Code": "ZW", "Name": "Zimbabwe" }]
        };

        this.searchtimeout = null;

        this.renderSearchBox = this.renderSearchBox.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.takeSearchResult = this.takeSearchResult.bind(this);
        this.closeSearchBox = this.closeSearchBox.bind(this);
        this.checkPopUp = this.checkPopUp.bind(this);
        this.getValidation = this.getValidation.bind(this);
        this.handleCreatorOUSelection = this.handleCreatorOUSelection.bind(this);
        this.handlePartnerSelection = this.handlePartnerSelection.bind(this);
        this.handlePartnerOUSelection = this.handlePartnerOUSelection.bind(this);
        this.handleMTSelection = this.handleMTSelection.bind(this);
        this.handleInstMTClick = this.handleInstMTClick.bind(this);
        this.checkPartnerInEWP = this.checkPartnerInEWP.bind(this);
        this.checkPartnerInEWPandGetData = this.checkPartnerInEWPandGetData.bind(this);
        this.getPartnerData = this.getPartnerData.bind(this);
        this.getInstitutionData = this.getInstitutionData.bind(this);
        this.saveCalendarData = this.saveCalendarData.bind(this);
        this.saveHVIData = this.saveHVIData.bind(this);

        this.getInstitutionsList();
        this.getCreatorOUList();
        if (props.data.partnerErasmusCode != "") {
            this.checkPartnerInEWP();
        }
    }

    render() {
        return (
            <div className={this.props.className}>
                <Title text="Partners definition" />

                <div>
                    <p>&nbsp;</p>
                    <h1>General information entered into the higher education institutions profile and updated by the higher education institution. The general institutional information about the institution is accessible to students.</h1>
                    <p>&nbsp;</p>
                </div>

                <div className="custom_table" id="partner_data">
                    <hr />
                    <h2 id="subtitleH2">Creator Details</h2>
                    {this.renderCreatorDetails()}

                    <hr />
                    <h2 id="subtitleH2">
                        Partner Details
                        <Help
                            title="This can take a while"
                            description="To decrease the number of requests to the registry, every 15 minutes the Dashboard will get the catalogue from registry, so sometimes this can take approximately 3 minutes to get the Institutions List. We apologize for the inconvenience."
                        />
                    </h2>
                    {this.renderPartnerDetails()}

                    <hr />
                    <h2 id="subtitleH2">Other Details</h2>
                    {this.renderCommonDetails()}
                </div>
            </div>
        );
    }

    /********************/
    /* RENDER FUNCTIONS */
    /********************/
    renderCreatorDetails() {
        return (
            <React.Fragment>
                {this.renderCreatorData()}
                {this.renderCreatorOrganizationalUnitRow()}
                {this.renderCreatorContacts()}
                {this.renderCreatorWebsites()}
            </React.Fragment>
        );
    }

    renderCreatorData() {
        return (
            <React.Fragment>
                <div className="row header_row">
                    <div className="column">
                        <Label text="Institution Name" />
                        <div><p>{this.state.creatorInstitution}</p></div>
                    </div>
                    <div className="column">
                        <Label text="Erasmus Code" />
                        <div><p>{this.state.creatorErasmusCode}</p></div>
                    </div>
                    <div className="column">
                        <Label text="Country" />
                        <div><p>{this.state.creatorCountry}</p></div>
                    </div>
                    <div className="column">
                        <Label text="City" />
                        <div><p>{this.state.creatorCity}</p></div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderCreatorOrganizationalUnitRow() {
        return (
            <React.Fragment>
                <div className="row header_row">
                    <div className="column">
                        <Label text="Organizational Unit" />
                        <Select
                            name="creatorOrganizationalUnit"
                            handleSelection={this.handleCreatorOUSelection}
                            value={this.state.creatorOUnit}
                            defaultValue={this.state.creatorOUnit}
                            multiple={false}
                            ounits={true}
                            options={this.state.creatorOUlist}
                            defaultMessage="Select OU"
                            refreshPage={this.props.refreshPage}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderCreatorContacts() {
        return (
            <React.Fragment>
                <div className="row header_row">
                    <div className="column">
                        <Label text="Contact Name" />
                        <TextArea
                            name="creatorContactName"
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            value={this.state.creatorContactName}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Contact Email" />
                        <TextArea
                            name="creatorContactEmail"
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            value={this.state.creatorContactEmail}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Contact Phone" />
                        <TextArea
                            name="creatorContactPhone"
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            value={this.state.creatorContactPhone}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderCreatorWebsites() {
        return (
            <React.Fragment>
                <div className="row header_row">
                    <h2 style={{ marginLeft: "0px" }}>Websites</h2>
                </div>
                <div className="row header_row">
                    <div className="column">
                        <Label text="General" />
                        <TextArea
                            name="creatorGeneralWebsite"
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            value={this.state.creatorGeneralWebsite}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Faculty/Faculties" />
                        <TextArea
                            name="creatorFacultyWebsite"
                            placeHolder=""
                            value={this.state.creatorFacultyWebsite}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Course Catalogue" />
                        <TextArea
                            name="creatorCourseWebsite"
                            placeHolder=""
                            value={this.state.creatorCourseWebsite}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderPartnerDetails() {
        return (
            <React.Fragment>
                {this.renderPartnerData()}
                {this.renderPartnerEWPRow()}
                {this.renderPartnerOrganizationalUnitRow()}
                {this.renderPartnerContacts()}
                {this.renderPartnerWebsites()}
            </React.Fragment>
        );
    }

    renderPartnerData() {
        let searchingText = <p />;
        let erasmusCodeValidation = <p />
        if (this.state.searchingMT) { searchingText = <p style={{ marginTop: "20px" }}>Searching...</p>; }
        else if (this.state.searchingMTError) { searchingText = <p style={{ color: "red", marginTop: "20px" }}>Institution not found by PIC, but you can fill the Erasmus Code (with spaces) field or fill all manually</p>; }

        if (!this.state.isErasmusCodeValid && this.state.getPDWasClickedAtLeastOnce) { erasmusCodeValidation = <p style={{ color: "red" }}>Erasmus Code not valid</p>; }


        return (
            <React.Fragment>
                <div className="row header_row">
                    <div className="column">
                        <Label text="Institutions available" />
                        <select name="partnerInstsAvailable" value={this.state.partnerInstsAvailable} onChange={(event) => this.handlePartnerSelection(event)}>
                            <option key={"partnerInstsAvailable"} value="" defaultChecked>(Select an institution)</option>
                            {this.state.instList.map((value, index) => {
                                return <option key={value.SCHAC + "-" + value.ECODE} value={value.ECODE}>{value.ECODE} - {value.SCHAC}</option>
                            })}
                        </select>
                        <div id="searchingText">
                            {searchingText}
                        </div>
                    </div>
                    <div className="column">
                        <Label text="Erasmus Code" />
                        <TextArea
                            name="partnerErasmusCode"
                            placeHolder="(Required)"
                            value={this.state.partnerErasmusCode}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                            readOnly={true}
                        />
                    </div>
                    <div className="column">
                        <Label text="Institution Name" />
                        <TextArea
                            name="partnerInstitution"
                            placeHolder="(Required)"
                            value={this.state.partnerInstitution}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            // readOnly={(this.state.getPDWasClickedAtLeastOnce && (this.state.searchingMTError || this.state.mtPlusPIC === "")) ? false : true }
                            readOnly={false}
                        />
                    </div>
                    <div className="column">
                        <Label text="Country" />
                        <TextArea
                            name="partnerCountry"
                            placeHolder=""
                            value={this.state.partnerCountry}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                            // readOnly={(this.state.getPDWasClickedAtLeastOnce && (this.state.searchingMTError || this.state.mtPlusPIC === "")) ? false : true }
                            readOnly={false}
                        />
                    </div>
                    <div className="column">
                        <Label text="City" />
                        <TextArea
                            name="partnerCity"
                            placeHolder=""
                            value={this.state.partnerCity}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            // readOnly={(this.state.getPDWasClickedAtLeastOnce && (this.state.searchingMTError || this.state.mtPlusPIC === "")) ? false : true }
                            readOnly={false}
                        />
                    </div>
                </div>
                <div className="row">
                    <p id="ewp_info"></p>
                </div>
            </React.Fragment>
        );
    }

    renderPartnerEWPRow() {
        if (this.state.partnerEWPStatus == 1) {
            return (
                <React.Fragment>
                    <div className="row header_row">
                        <h3 style={{ color: "green" }}>The IIAs of the partner are managed by a node in the EWP network. This agreement will be sent through the EWP Network.</h3>
                        <p>&nbsp;</p>
                    </div>
                </React.Fragment>
            );
        }
        if (this.state.partnerEWPStatus == 2) {
            return (
                <React.Fragment>
                    <div className="row header_row">
                        <h3 style={{ color: "green" }}>The IIAs of the partner are managed by the Dashboard in the EWP network. This agreement will not be sent through the EWP Network and treated internally in the Dashboard.</h3>
                        <p>&nbsp;</p>
                    </div>
                </React.Fragment>
            );
        }
        if (this.state.partnerEWPStatus == -1) {
            return (
                <React.Fragment>
                    <div className="row header_row">
                        <h3 style={{ color: "orange" }}>The IIAs of the partner are not managed by any node in the EWP network. This agreement will not be sent through the EWP Network.</h3>
                        <p>&nbsp;</p>
                    </div>
                </React.Fragment>
            );
        }
        if (this.state.partnerEWPStatus == 0) {
            return (
                <React.Fragment>
                    <div className="row header_row">
                        <h3 style={{ color: "orange" }}>It was not possible to get the information about the partner on the EWP Network. It may not be possible to send the IIA through the EWP Network. Please contact the Administrator.</h3>
                        <p>&nbsp;</p>
                    </div>
                </React.Fragment>
            );
        }
    }

    renderPartnerOrganizationalUnitRow() {
        return (
            <React.Fragment>
                <div className="row header_row">
                    <div className="column">
                        <Label text="Organizational Unit" />
                        <Select
                            name="partnerOrganizationalUnit"
                            handleSelection={this.handlePartnerOUSelection}
                            value={this.state.partnerOUnit}
                            defaultValue={this.state.partnerOUnit}
                            multiple={false}
                            ounits={true}
                            options={this.state.partnerOUlist}
                            defaultMessage="Select OU"
                            refreshPage={this.props.refreshPage}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderPartnerContacts() {
        return (
            <React.Fragment>
                <div className="row header_row">
                    <div className="column">
                        <Label text="Contact Name" />
                        <TextArea
                            name="partnerContactName"
                            value={this.state.partnerContactName}
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Contact Email" />
                        <TextArea
                            name="partnerContactEmail"
                            value={this.state.partnerContactEmail}
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Contact Phone" />
                        <TextArea
                            name="partnerContactPhone"
                            value={this.state.partnerContactPhone}
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderPartnerWebsites() {
        return (
            <React.Fragment>
                <div className="row header_row">
                    <h2 style={{ marginLeft: "0px" }}>Websites</h2>
                </div>
                <div className="row header_row">
                    <div className="column">
                        <Label text="General" />
                        <TextArea
                            name="partnerGeneralWebsite"
                            value={this.state.partnerGeneralWebsite}
                            placeHolder=""
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Faculty/Faculties" />
                        <TextArea
                            name="partnerFacultyWebsite"
                            placeHolder=""
                            value={this.state.partnerFacultyWebsite}
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                    <div className="column">
                        <Label text="Course Catalogue" />
                        <TextArea
                            name="partnerCourseWebsite"
                            placeHolder=""
                            value={this.state.partnerCourseWebsite}
                            validation={this.getValidation}
                            handleSelection={this.handleSelection}
                            refreshPage={this.props.refreshPage}
                            setErrors={this.props.setErrors}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderCommonDetails() {
        return (
            <React.Fragment>
                {this.renderAcademicYears()}
            </React.Fragment>
        );
    }

    renderAcademicYears() {
        let academicYearsEnd = [];

        if (this.academicYearsStartSelectionIndex > 0) { academicYearsEnd = GlobVar.academicYears.slice(this.academicYearsStartSelectionIndex - 1); }
        else { academicYearsEnd = GlobVar.academicYears.slice(this.academicYearsStartSelectionIndex); }

        return (
            <React.Fragment>
                <div className="row header_row">
                    <div className="column">
                        <Label text="Academic Year (start)" />
                        <Select
                            className="column"
                            name="academicYearStart"
                            multiple={false}
                            ounits={false}
                            options={GlobVar.academicYears}
                            value={this.state.academicYearStart}
                            handleSelection={this.handleSelection}
                            defaultMessage="Required"
                            refreshPage={this.props.refreshPage}
                        />
                    </div>
                    <div className="column">
                        <Label text="Academic Year (end)" />
                        <Select
                            className="column"
                            name="academicYearEnd"
                            multiple={false}
                            ounits={false}
                            options={academicYearsEnd}
                            value={this.state.academicYearEnd}
                            handleSelection={this.handleSelection}
                            defaultMessage="Required"
                            refreshPage={this.props.refreshPage}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }

    /**********************/
    /* AUXILIAR FUNCTIONS */
    /**********************/
    handleSelection(selectionValue) {
        this.setState(selectionValue);

        let partnersDetails = JSON.parse(localStorage.getItem("partnersDetails"));
        let auxInfo = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));
        Object.keys(selectionValue).map((key, index) => {
            if (key === "partnerErasmusCode") {
                console.log("key: " + key + "\nvalue: " + selectionValue[key]);
                clearTimeout(this.searchtimeout);
                this.cleanInstitutionAndContactFields();

                if (selectionValue[key] !== "") {
                    this.searchtimeout = setTimeout(() => {
                        document.getElementById("searchingText").innerHTML = "Searching...";
                        document.getElementById("searchingText").style.marginTop = "20px";
                        document.getElementById("searchingText").style.color = "white";

                        this.setState({ isErasmusCodeValid: false });
                        auxInfo.partnerErasmusCodeValid = false;
                        localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(auxInfo));

                        this.getInstitutionData(selectionValue[key], (partnerData) => {
                            if (partnerData !== null && partnerData !== "") {
                                auxInfo.partnerErasmusCodeValid = true;
                                partnersDetails[key] = selectionValue[key];
                                localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(auxInfo));

                                partnersDetails["partnerInstitution"] = partnerData.getIIAmInstitution.NameInLatinCharacterSet;
                                partnersDetails["partnerCountry"] = partnerData.getIIAmInstitution.CountryName;
                                partnersDetails["partnerCity"] = partnerData.getIIAmInstitution.CityName;
                                localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));

                                this.setState({
                                    partnerInstitution: partnerData.getIIAmInstitution.NameInLatinCharacterSet,
                                    partnerCountry: partnerData.getIIAmInstitution.CountryName,
                                    partnerCity: partnerData.getIIAmInstitution.CityName,
                                    isErasmusCodeValid: true
                                });

                                this.checkPartnerInEWP();
                            }
                            else {
                                this.checkPartnerInEWP();
                            }
                        });
                    }, 1500);
                }
            }
            else if (key === "academicYearStart") {
                this.academicYearsStartSelectionIndex = document.getElementsByName(key)[0].selectedIndex;
            }
            else {
                this.setState({ key: key });
            }
            partnersDetails[key] = selectionValue[key];
            localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(auxInfo));
        });
        this.refreshPages();
    }

    handlePartnerSelection(event) {
        let partnersDetails = JSON.parse(localStorage.getItem("partnersDetails"));
        let auxInfo = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));
        let value = event.target.value;

        this.getPartnerECWithSpace(value, (ecodeWithSpaces) => {
            ecodeWithSpaces = (ecodeWithSpaces !== "") ? ecodeWithSpaces : value;
            document.getElementById("searchingText").innerHTML = "Searching...";
            document.getElementById("searchingText").style.marginTop = "20px";
            document.getElementById("searchingText").style.color = "white";

            // this.setState({ isErasmusCodeValid: false });
            // auxInfo.partnerErasmusCodeValid = false;
            // localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(auxInfo));
            /*DEL*/console.log("ecodeWithSpaces: " + ecodeWithSpaces);

            this.setState({
                partnerEWPStatus: -2,
                partnerInstsAvailable: value,
                partnerErasmusCode: ecodeWithSpaces,
                partnerInstitution: "",
                partnerCountry: "",
                partnerCity: "",
                partnerContactName: "",
                partnerContactEmail: "",
                partnerContactPhone: "",
                partnerGeneralWebsite: "",
                partnerFacultyWebsite: "",
                partnerCourseWebsite: "",
                partnerOUnit: "",
                partnerOUlist: [],
                isErasmusCodeValid: false
            });

            auxInfo.partnerErasmusCodeValid = false;
            partnersDetails["partnerErasmusCode"] = ecodeWithSpaces;
            partnersDetails["partnerInstitution"] = "";
            partnersDetails["partnerCountry"] = "";
            partnersDetails["partnerCity"] = "";
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(auxInfo));
            localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));

            this.getInstitutionData(ecodeWithSpaces, (partnerData) => {
                if (partnerData !== null && partnerData !== "") {
                    auxInfo.partnerErasmusCodeValid = true;
                    // partnersDetails[key] = ecodeWithSpaces;
                    localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(auxInfo));

                    partnersDetails["partnerErasmusCode"] = partnerData.getIIAmInstitution.ErasmusCode;
                    partnersDetails["partnerInstitution"] = partnerData.getIIAmInstitution.NameInLatinCharacterSet;
                    partnersDetails["partnerCountry"] = partnerData.getIIAmInstitution.CountryName;
                    partnersDetails["partnerCity"] = partnerData.getIIAmInstitution.CityName;
                    partnersDetails['partnerContactName']='';
                    partnersDetails['partnerContactEmail']='';
                    partnersDetails['partnerContactPhone']='';
                    partnersDetails['partnerGeneralWebsite']='';
                    partnersDetails['partnerFacultyWebsite']='';
                    partnersDetails['partnerCourseWebsite']='';
                    localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));

                    this.setState({
                        partnerInstsAvailable: value,
                        partnerErasmusCode: partnerData.getIIAmInstitution.ErasmusCode,
                        partnerInstitution: partnerData.getIIAmInstitution.NameInLatinCharacterSet,
                        partnerCountry: partnerData.getIIAmInstitution.CountryName,
                        partnerCity: partnerData.getIIAmInstitution.CityName,
                        isErasmusCodeValid: true
                    });

                    this.checkPartnerInEWP();
                }
                else {
                    this.checkPartnerInEWP();
                }
            });
        });
    }

    handleCreatorOUSelection(selectionValue) {
        this.setState({
            creatorOUnit: selectionValue
        });
        let partnersDetails = JSON.parse(localStorage.getItem("partnersDetails"));
        partnersDetails["creatorOUnit"] = selectionValue;
        localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));
    }
    handlePartnerOUSelection(selectionValue) {
        this.setState({
            partnerOUnit: selectionValue
        });
        let partnersDetails = JSON.parse(localStorage.getItem("partnersDetails"));
        partnersDetails["partnerOUnit"] = selectionValue;
        localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));
    }

    getValidation(type, value) {
        const validator = new Validator(value);
        let aux = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));

        if (type === "creatorInstitution" || type === "creatorContactName" || type === "partnerInstitution"
            || type === "useFactsheetData") {
            let message = validator.validateRegularNamesOfRequiredFields();
            aux.isRegularNamesValid = (message === "");
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            return message;
        }
        else if (type === "creatorCountry" || type === "creatorCity" || type === "partnerCountry" || type === "partnerCity" || type === "partnerContactName") {
            let message = validator.validateRegularNames();
            aux.isRegularNamesValid = (message === "");
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            return message;
        }
        else if (type === "creatorErasmusCode" || type === "partnerErasmusCode") {
            return validator.validateErasmusCode(false);
        }
        else if (type === "creatorContactEmail" || type === "partnerContactEmail") {
            let message = validator.validateEmailFormat(false);
            aux.isEmailValid = (message === "");
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            return message;
        }
        else if (type === "creatorContactPhone" || type === "partnerContactPhone") {
            let message = validator.validatePhoneFaxNumber(true);
            aux.isPhoneValid = (message === "");
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            return message;
        }
        else if (type === "creatorGeneralWebsite" || type === "creatorFacultyWebsite" || type === "creatorCourseWebsite" ||
            type === "partnerGeneralWebsite" || type === "partnerFacultyWebsite" || type === "partnerCourseWebsite") {
            let message = validator.validateUrlFormat(true);
            aux.isWebsiteValid = (message === "");
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            return message;
        }
        else if (type === "iiaCode") {
            return validator.validateCodes(false);
        }
        else if (type === "creatorSigningDate") {
            return "";
        }

        this.refreshPages();
    }

    cleanInstitutionAndContactFields() {
        let partnersDetails = JSON.parse(localStorage.getItem("partnersDetails"));

        partnersDetails.partnerInstitution = "";
        partnersDetails.partnerCountry = "";
        partnersDetails.partnerCity = "";
        partnersDetails.partnerContactEmail = "";
        partnersDetails.partnerContactName = "";
        partnersDetails.partnerContactPhone = "";
        partnersDetails.partnerGeneralWebsite = "";
        partnersDetails.partnerFacultyWebsite = "";
        partnersDetails.partnerCourseWebsite = "";

        localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));

        this.setState({
            partnerEWPStatus: -2,
            partnerInstitution: "",
            partnerCountry: "",
            partnerCity: "",
            partnerContactEmail: "",
            partnerContactName: "",
            partnerContactPhone: "",
            partnerGeneralWebsite: "",
            partnerFacultyWebsite: "",
            partnerCourseWebsite: ""
        });
    }

    /********************************/
    /* INSTITUTION SEARCH FUNCTIONS */
    /********************************/
    renderSearchBox(value) {
        if (this.state.searchValue.length > 0) {
            if (!this.state.searchOpen) {
                this.setState({
                    searchOpen: true
                }, () => {
                    this.handlePopUpList(true);
                });
            }
            return <SearchInstitution value={value} takeSearchResult={this.takeSearchResult} checkPopUp={this.checkPopUp} />;
        }
        else if (this.state.searchOpen) {
            this.handlePopUpList(false);
            this.setState({
                searchOpen: false
            })
        }
    }

    takeSearchResult(newValue) {
        this.setState({
            partnerInstitution: newValue.NameInLatinCharacterSet,
            partnerErasmusCode: newValue.ErasmusCode,
            partnerCountry: newValue.City.Country.CountryName,
            partnerCity: newValue.City.CityName,
            searchOpen: false,
            searchValue: ""
        }, () => {
            this.handlePopUpList(false);
            this.closeSearchBox();
        });

        let partnersDetails = JSON.parse(localStorage.getItem("partnersDetails"));
        partnersDetails["partnerInstitution"] = newValue.NameInLatinCharacterSet;
        partnersDetails["partnerErasmusCode"] = newValue.ErasmusCode;
        partnersDetails["partnerCountry"] = newValue.City.Country.CountryName;
        partnersDetails["partnerCity"] = newValue.City.CityName;
        localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));
        this.getPartnerOUList();
        this.refreshPages();
    }

    searchInstitution() {
        clearTimeout(this.searchtimeout);
        const thisClass = this;
        let value = "";
        if (this.state.searchKey === "partnerInstitution") {
            value = thisClass.state.partnerInstitution;
        }

        this.searchtimeout = setTimeout(() => {
            thisClass.setState({
                searchValue: value
            })
        }, 500);
    }

    closeSearchBox() {
        this.setState({
            searchOpen: false
        }, () => { });
    }

    handlePopUpList(statusPopUp) {
        this.setState({
            statusPopUp
        }, () => { });
    }

    checkPopUp() {
        if (this.state.statusPopUp) {
            return " overlap";
        }
        return "";
    }

    saveValue(value) {
        let creationPageDisplaying = JSON.parse(localStorage.getItem("creationPageDisplaying"));
        let creatingIIA = JSON.parse(localStorage.getItem("creatingIIA"));

        if (creationPageDisplaying.isDisplayingPartnerPage) {
            let creatingPartner = JSON.parse(localStorage.getItem("creatingPartner"));

            if (this.props.name === "partnerErasmusCode") {
                creatingPartner[this.props.name] = value.ErasmusCode;
            }
            else if (this.props.name === "allowFactsheet") {
                if (value === "0") {
                    creatingPartner[this.props.name] = 0;
                } else {
                    creatingPartner[this.props.name] = 1;
                }
            } else {
                creatingPartner[this.props.name] = value;
            }
            localStorage.setItem("creatingPartner", JSON.stringify(creatingPartner));
        } else if (creatingIIA !== null) {
            creatingIIA[0][this.props.name] = value;
            localStorage.setItem("creatingIIA", JSON.stringify(creatingIIA));
        }
    }

    refreshPages() {
        this.setState({
            reloadPage: !this.state.reloadPage
        });
        this.props.refreshPage();
    }

    /**
     * Gets only the OUnits that are active, so user cannot select the OUnits not active.
     * 
     * @param {Object} ouList 
     */
    getOnlyActiveOUnits(ouList) {
        let ounitsList = [];

        if (ouList != null) {
            ouList.map(ou => {
                if (ou.active) {
                    ounitsList.push(ou);
                }
            });
        }

        console.log("ounitsList:", ounitsList);
        return ounitsList;
    }

    /**
     * Compares the Organizational Units IDs saved in the local database with the Organizational Units IDs
     * obtained from Institutions data.
     * The point of doing this is to check if the local list needs to be updated.
     * 
     * @param {Object} obtainedOUList 
     * @param {Object} localOUList 
     * @returns {boolean} true if every OUnit ID is in the local list and false otherwise
     */
    isLocalOUListEqualToObtainedOne(obtainedOUList, localOUList) {
        /* First check, the length of both lists. */
        /* It removes duplicates from localOUList to calculate the length of different OUnits, */
        /* because this list can have multiple elements with the same ID but in different language, for example. */
        let localOUListWithNoDuplicates = localOUList.filter((value, index) => localOUList.map(e => e.ounit_id).indexOf(value.ounit_id) === index);
        let isLocalListUpdated = (obtainedOUList.length === localOUListWithNoDuplicates.length) ? true : false;
        if (!isLocalListUpdated) {
            console.log("Failed in first check: the lists do not have the same length (obtainedOUList length = " + obtainedOUList.length + ", localOUList length = " + localOUListWithNoDuplicates.length + ").");
            return isLocalListUpdated;
        }

        /* Second check, find if every ID from obtained list is in local list. */
        /* Sets isLocalListUpdated as false by default so if it finds the ID will change it to true. */
        /* If in the end of the localOUList cycle this value stills false, that's because there is no ID, which means the localOUList is outdated. */
        for (let obtainedOUindex = 0; obtainedOUindex < obtainedOUList.length; obtainedOUindex++) {
            isLocalListUpdated = false;
            for (let localOUindex = 0; localOUindex < localOUList.length; localOUindex++) {
                if (obtainedOUList[obtainedOUindex] === localOUList[localOUindex].ounit_id) {
                    isLocalListUpdated = true;
                    break;
                }
            }

            if (!isLocalListUpdated) {
                console.log("Failed in second check: the ID", obtainedOUList[obtainedOUindex], " at row", obtainedOUindex, " is not present at the localOUList.");
                return isLocalListUpdated;
            }
        }

        console.log("The localOUList is updated.");
        return isLocalListUpdated;
    }

    getInstitutionData(erasmusCode, callback) {
        if (erasmusCode !== "") {
            erasmusCode = (erasmusCode.replace(/\s+/g, "") === JSON.parse(localStorage.getItem("currentErasmusCodeNoSpaces"))?.erasmusCode) ? GlobVar.encryptWithKey(erasmusCode).toString() : erasmusCode;

            return this.props.getInstitutionData({
                variables: { "erasmusCode": erasmusCode }
            })
                .then((res) => {
                    if (res.data == null) {
                        console.log("An error has occurred while getting Institution data.");
                        return callback(null);
                    } else {
                        console.log("The Institution data was obtained successfully: " + JSON.stringify(res));
                    }
                    return callback(res.data);
                })
                .catch((err) => {
                    console.log("Error while getting the Institution data: " + err);
                    document.getElementById("searchingText").innerHTML = "";
                    return callback("");
                })
        }
        return callback(null)
    }


    getCreatorOUList() {
        let aux = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));
        this.props.listOU({
            variables: {
                "ErasmusCodeIn": localStorage.getItem("ErasmusCode")
            }
        }).then((x) => {
            if (x.data.error) {
                console.log("Error getting Organizational Units");
            } else {
                if (x.data.listOU) {
                    console.log("Successfully retrieved Organizational Units");
                    let ounitsList = this.getOnlyActiveOUnits(x.data.listOU);

                    this.setState({
                        creatorOUlist: ounitsList
                    });
                    aux.creatorOUnitList = ounitsList;
                    localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
                } else {
                    console.log("Error getting Organizational Units");
                }
            }
        });
    }

    getPartnerOUList() {
        let aux = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));

        if (JSON.parse(localStorage.getItem("partnersDetails")).partnerErasmusCode != "") {
            if (this.state.partnerEWPStatus == 2 || this.state.partnerEWPStatus == -1) {
                this.props.listOU({
                    variables: {
                        "ErasmusCodeIn": JSON.parse(localStorage.getItem("partnersDetails")).partnerErasmusCode
                    }
                }).then((x) => {
                    if (x.data.error) {
                        console.log("Error getting Organizational Units");
                    } else {
                        if (x.data.listOU) {
                            console.log("Successfully retrieved Organizational Units");
                            let ounitsList = this.getOnlyActiveOUnits(x.data.listOU);

                            this.setState({
                                partnerOUlist: ounitsList
                            });
                            aux.partnerOUnitList = ounitsList;
                            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
                        } else {
                            console.log("Error getting Organizational Units");
                        }
                    }
                    document.getElementById("searchingText").innerHTML = "";
                });
            } else {
                this.setState({
                    partnerOUlist: []
                });
                aux.partnerOUnitList = [];
                localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            }
        }
    }

    getPartnerEWPOUnits(eCode, ouCodesList) {
        let aux = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));

        if (JSON.parse(localStorage.getItem("partnersDetails")).partnerErasmusCode != "") {
            // this.props.listOU({
            //     variables: {
            //         "ErasmusCodeIn": eCode
            //     }
            // }).then((x) => {
            //     if ((x.data.error || x.data.listOU == null || x.data.listOU.length == 0) || 
            //         (!this.isLocalOUListEqualToObtainedOne(ouCodesList, x.data.listOU.filter(ou => { return ou.is_ewp_partner; })))) {
            //         if (x.data.listOU) {
            //             console.log("Successfully retrieved Organizational Units");
            //             let ounitsList = this.getOnlyActiveOUnits(x.data.listOU);

            //             ouCodesList.map(code => {
            //                 let isAlreadyInTheList = false;
            //                 ounitsList.forEach(ounit => {
            //                     if (ounit.ounit_id === code) { isAlreadyInTheList = true; }
            //                 });
            //                 if (!isAlreadyInTheList) { 
            //                     ounitsList.push({ ounit_id: code, institution_ecode: eCode, abbreviation: "", is_ewp_partner: true, active: true, lang: "", name: code,  }); 
            //                 }
            //             });

            //             this.setState({
            //                 partnerOUlist: ounitsList
            //             });
            //             aux.partnerOUnitList = ounitsList;
            //             localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            //             document.getElementById("searchingText").innerHTML = "The Organizational Units saved locally for this HEI need to be updated. Trying get them from EWP partner...";
            //         }
            //         else {
            //             console.log("Error getting Organizational Units");
            //             document.getElementById("searchingText").innerHTML = "There are no Organizational Units for this HEI saved locally. Trying get them from EWP partner...";
            //         }
            this.props.getEWPOUnits({
                variables: {
                    "ErasmusCode": eCode,
                    "clientHeiEC": localStorage.getItem("ErasmusCode")
                    // "ounitsList": ouCodesList
                }
            }).then((response) => {
                if (response.data.error) {
                    console.log("Error getting Organizational Units");
                } else {
                    if (response.data.getEWPOUnits.Success === 1) {
                        console.log("Successfully retrieved Organizational Units");

                        this.setState({
                            partnerOUlist: response.data.getEWPOUnits.OUList
                        });
                        aux.partnerOUnitList = response.data.getEWPOUnits.OUList;
                        localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
                    } else {
                        console.log("Error getting Organizational Units");
                    }
                }
                document.getElementById("searchingText").innerHTML = "";
            });
            // } else {
            //     if (x.data.listOU) {
            //         console.log("Successfully retrieved Organizational Units");
            //         let ounitsList = this.getOnlyActiveOUnits(x.data.listOU);

            //         this.setState({
            //             partnerOUlist: ounitsList
            //         });
            //         aux.partnerOUnitList = ounitsList;
            //         localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
            //     } else {
            //         console.log("Error getting Organizational Units");
            //     }
            // }
            //     document.getElementById("searchingText").innerHTML = "";
            // });
        }
    }

    createDefaultDataIfNotExists(ecode) {
        this.saveCalendarData(ecode);
        this.saveHVIData(ecode);
    }

    saveCalendarData(ecode) {
        this.props.SaveCalendarIfNotExists({
            variables: {
                "ErasmusCode": GlobVar.encryptWithKey(ecode).toString(),
            },
        }).then((x) => {
            if (x.data.error) {
                //Already there - nothing happens
            } else {
                if (x.data.saveCalendarIfNotExists.Success) {
                    //Success - nothing happens
                } else {
                    //Already there - nothing happens
                }
            }
        });
    }

    saveHVIData(ecode) {
        this.props.SaveHVIIfNotExists({
            variables: {
                "ErasmusCode": GlobVar.encryptWithKey(ecode).toString(),
            },
        }).then((x) => {
            if (x.data.error) {
                //Already there - nothing happens
            } else {
                if (x.data.saveHVIIfNotExists.Success) {
                    //Success - nothing happens
                } else {
                    //Already there - nothing happens
                }
            }
        });
    }

    handleMTSelection(selectionValue) {
        this.setState(selectionValue);

        Object.keys(selectionValue).map((key, index) => {
            if (key === "creatorInstMT") {
                this.setState({
                    mtPlusPIC: selectionValue.creatorInstMT,
                    previousPIC: selectionValue.creatorInstMT
                });
            }
        });

        this.refreshPages();
    }

    handleInstMTClick(event) {
        let aux = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));
        const re = /^[0-9\b]+$/;

        if (this.state.mtPlusPIC != "" && !this.state.searchingMT && re.test(this.state.mtPlusPIC)) {

            this.setState({
                searchingMT: 1,
                getPDWasClickedAtLeastOnce: true
            });
            aux.getPDWasClickedAtLeastOnce = true;
            localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));

            (async () => {
                axios.get(
                    GlobVar.getEWPNodeLink() + "/out/mtplus/institutions",
                    {
                        params: { inputPIC: this.state.mtPlusPIC },
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Access-Control-Allow-Header': '*',
                            'Access-Control-Allow-Headers': '*',
                            'Access-Control-Allow-Origin': '*'
                        }
                    }
                ).then(response => {
                    this.setState({
                        searchingMT: 0,
                        searchingMTError: false
                    });
                    console.log(response.data);
                    if (response.data.Hei) {
                        if (response.data.Hei.length > 0) {
                            const hei = response.data.Hei[0];
                            if (hei.ECode.length > 0) {

                                var replace = " +";
                                var re = new RegExp(replace, "g");
                                let ecode = hei.ECode[0].replace(re, " ")

                                if (ecode != JSON.parse(localStorage.getItem("currentErasmusCode")).erasmusCode) {

                                    let partnersDetails = JSON.parse(localStorage.getItem("partnersDetails"));

                                    this.setState({
                                        partnerErasmusCode: ecode
                                    });
                                    partnersDetails["partnerErasmusCode"] = ecode;

                                    if (hei.Name.length > 0) {
                                        this.setState({
                                            partnerInstitution: hei.Name[0]
                                        });
                                        partnersDetails["partnerInstitution"] = hei.Name[0];
                                    }

                                    if (hei.MailAdd.length > 0) {
                                        if (hei.MailAdd[0].Local.length > 0) {
                                            this.setState({
                                                partnerCity: hei.MailAdd[0].Local[0]
                                            });
                                            partnersDetails["partnerCity"] = hei.MailAdd[0].Local[0];
                                        }

                                        if (hei.MailAdd[0].Country.length > 0) {
                                            for (let i = 0; i < this.state.countryList.length; i++) {
                                                if (this.state.countryList[i]["Code"] == hei.MailAdd[0].Country[0]) {
                                                    this.setState({
                                                        partnerCountry: this.state.countryList[i]["Name"]
                                                    });
                                                    partnersDetails["partnerCountry"] = this.state.countryList[i]["Name"];
                                                }
                                            }
                                        }
                                    }

                                    localStorage.setItem("partnersDetails", JSON.stringify(partnersDetails));
                                    this.checkPartnerInEWP();
                                    this.createDefaultDataIfNotExists(ecode);
                                    this.createDefaultDataIfNotExists(JSON.parse(localStorage.getItem("currentErasmusCode")).erasmusCode);
                                }
                            }
                        }
                    } else {
                        this.setState({
                            searchingMT: 0,
                            searchingMTError: true
                        });
                        console.log('inside then block but with Hei null');
                    }
                }).catch(error => {
                    this.setState({
                        searchingMT: 0,
                        searchingMTError: true
                    });
                    console.log('inside catch block.');
                    if (error.response) {
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                    console.log(error);
                });
            })();
        }
    }

    getPartnerData(status) {
        if (status == 1) {
            let aux = JSON.parse(localStorage.getItem("iiaCreationAuxiliarInformation"));
            console.log("Get partner data");

            this.props.getEWPInstitutionData({
                variables: {
                    "CreatorErasmusCode": localStorage.getItem("ErasmusCode"),
                    "PartnerErasmusCode": JSON.parse(localStorage.getItem("partnersDetails")).partnerErasmusCode,
                },
            }).then((x) => {
                if (x.data.getEWPInstitutionData.Success) {
                    console.log("x: " + JSON.stringify(x));
                    let ounitsList = this.getOnlyActiveOUnits(x.data.getEWPInstitutionData.OUList);

                    this.setState({
                        partnerOUlist: ounitsList
                    });

                    let partner = JSON.parse(localStorage.getItem("partnersDetails"));
                    partner.partnerContactEmail = (x.data.getEWPInstitutionData.ContactEmail != null) ? x.data.getEWPInstitutionData.ContactEmail : "";
                    partner.partnerContactName = (x.data.getEWPInstitutionData.ContactName != null) ? x.data.getEWPInstitutionData.ContactName : "";
                    partner.partnerContactPhone = (x.data.getEWPInstitutionData.ContactPhone != null) ? x.data.getEWPInstitutionData.ContactPhone : "";
                    partner.partnerGeneralWebsite = (x.data.getEWPInstitutionData.WebsiteGeneral != null) ? x.data.getEWPInstitutionData.WebsiteGeneral : "";
                    partner.partnerFacultyWebsite = (x.data.getEWPInstitutionData.WebsiteFaculty != null) ? x.data.getEWPInstitutionData.WebsiteFaculty : "";
                    partner.partnerCourseWebsite = (x.data.getEWPInstitutionData.WebsiteCourse != null) ? x.data.getEWPInstitutionData.WebsiteCourse : "";
                    aux.partnerErasmusCodeValid = true;
                    aux.partnerOUnitList = ounitsList;

                    localStorage.setItem("partnersDetails", JSON.stringify(partner));
                    localStorage.setItem("iiaCreationAuxiliarInformation", JSON.stringify(aux));
                    this.setState({
                        isErasmusCodeValid: true,
                        partnerContactEmail: (x.data.getEWPInstitutionData.ContactEmail != null) ? x.data.getEWPInstitutionData.ContactEmail : "",
                        partnerContactName: (x.data.getEWPInstitutionData.ContactName != null) ? x.data.getEWPInstitutionData.ContactName : "",
                        partnerContactPhone: (x.data.getEWPInstitutionData.ContactPhone != null) ? x.data.getEWPInstitutionData.ContactPhone : "",
                        partnerGeneralWebsite: (x.data.getEWPInstitutionData.WebsiteGeneral != null) ? x.data.getEWPInstitutionData.WebsiteGeneral : "",
                        partnerFacultyWebsite: (x.data.getEWPInstitutionData.WebsiteFaculty != null) ? x.data.getEWPInstitutionData.WebsiteFaculty : "",
                        partnerCourseWebsite: (x.data.getEWPInstitutionData.WebsiteCourse != null) ? x.data.getEWPInstitutionData.WebsiteCourse : ""
                    });

                    let ounitCodesList = [];
                    ounitsList.map((ounit) => {
                        ounitCodesList.push(ounit.ounit_id);
                    });
                    this.getPartnerEWPOUnits(JSON.parse(localStorage.getItem("partnersDetails")).partnerErasmusCode, ounitCodesList);
                    this.getValidation("partnerContactName", this.state.partnerContactName);
                    document.getElementById("searchingText").innerHTML = "";
                }
                else if (!x.data.getEWPInstitutionData.Success) {
                    console.log(x.data.getEWPInstitutionData.Message);
                    document.getElementById("searchingText").innerHTML = "";
                }
            }).catch(error => {
                console.log(error);
                document.getElementById("searchingText").innerHTML = "";
            });
        } else {
            this.getPartnerOUList();
        }
    }

    checkPartnerInEWP() {
        this.props.isIIAManagedByEWP({
            variables: {
                "ErasmusCode": JSON.parse(localStorage.getItem("partnersDetails")).partnerErasmusCode,
            },
        }).then((x) => {
            if (x.data.error) {
                this.setState({
                    isPartnerInEWPSearch: true,
                    partnerEWPStatus: 0
                });
            } else {
                console.log("(checkPartnerInEWP) Is partner in EWP?");
                console.log(x.data);
                switch (x.data.isIIAManagedByEWP.Success) {
                    case 1:
                        //By a node in EWP
                        this.setState({
                            isPartnerInEWPSearch: true,
                            partnerEWPStatus: 1,
                        });
                        break;
                    case 2:
                        //By Dashboard
                        this.setState({
                            isPartnerInEWPSearch: true,
                            partnerEWPStatus: 2
                        });
                        break;
                    case -1:
                        //Not in EWP
                        this.setState({
                            isPartnerInEWPSearch: true,
                            partnerEWPStatus: -1
                        });
                        break;
                    default:
                        //Some error
                        this.setState({
                            isPartnerInEWPSearch: true,
                            partnerEWPStatus: 0
                        });
                        break;
                }
                this.getPartnerData(x.data.isIIAManagedByEWP.Success);
            }
        })
            .catch((error) => {
                console.log("Error in checkPartnerInEWP: " + error);
            });
    }

    checkPartnerInEWPandGetData() {
        this.props.getEWPStaticData({
            variables: {
                "PartnerErasmusCode": JSON.parse(localStorage.getItem("partnersDetails")).partnerErasmusCode,
                "clientHeiEC": localStorage.getItem("ErasmusCode")
            },
        }).then((x) => {
            if (x.data.error) {
                this.setState({
                    partnerStaticData: null,
                });
            } else {
                console.log("(checkPartnerInEWPandGetData) Is partner in EWP?");
                console.log(x.data);
                switch (x.data.getEWPStaticData.Success) {
                    case 1:
                        //By a node in EWP
                        console.log(x.data.getEWPStaticData);
                        if (x.data.getEWPStaticData.StaticData != null) {
                            this.setState({
                                partnerStaticData: x.data.getEWPStaticData.StaticData,
                            });
                        }
                        break;
                    default:
                        this.setState({
                            partnerStaticData: null,
                        });
                        break;
                }
            }
        });
    }

    getInstitutionsList() {
        this.props.getEWPInstitutionsList({
            variables: {
                "CreatorErasmusCode": GlobVar.encryptWithKey(JSON.parse(localStorage.getItem("currentErasmusCode")).erasmusCode.replace(/\s/g, "").toUpperCase()).toString(),//props.location.state.data.creator_institution_code
            },
        }).then((x) => {
            if (x.data.error) {
                this.setState({
                    instListFetched: -1
                });
            } else {
                switch (x.data.getEWPInstitutionsList.Success) {
                    case 1:
                        //By a node in EWP
                        this.setState({
                            instListFetched: 1,
                            instList: x.data.getEWPInstitutionsList.InstList,
                        });
                        break;
                    default:
                        //Some error
                        this.setState({
                            instListFetched: -1
                        });
                        break;
                }
            }
        });
    }

    getPartnerECWithSpace(erasmusCode, callback) {
        return this.props.checkPartnerEC({
            variables: {
                "ErasmusCode": erasmusCode,
            },
        })
            .then((x) => {
                if (x.data == null) {
                    console.log("An error has occurred while checking Erasmus Code.");
                    return callback("");
                } else {
                    console.log("The Erasmus Code with space successfully obtained: " + JSON.stringify(x));
                }
                return callback(x.data.checkPartnerEC.ErasmusCode);
            })
            .catch((x) => {
                console.log("An error has occurred while checking Erasmus Code.");
                return callback("");
            });
    }
}

const getIIADefaultData = gql`
    mutation getIIADefaultData($ErasmusCode: String!, $isToCreate: Boolean) {
        getIIADefaultData(ErasmusCode: $ErasmusCode, isToCreate: $isToCreate) {
            stuNomAutumnTerm
            stuNomSpringTerm
            appNomAutumnTerm
            appNomSpringTerm
            appProcedureEmail
            appProcedurePhone
            appProcedureWebsite
            addReqWeeks
            ToRWeeks
            additionalRequirements {
                id
                requirement
                ects
                isced
                eqf
                details
                website
            }
            inclusionInfrastructure {
                id
                name
                specialNeeds
                description
                email
                phone
                website
            }
            inclusionService {
                id
                name
                specialNeeds
                description
                email
                phone
                website
            }
            housing_email
            housing_phone
            housing_website
            visa_email
            visa_phone
            visa_website
            insurance_email
            insurance_phone
            insurance_website
            additionalInformation {
                id
                information
                email
                phone
                website
            }
        }
    }
`;

const getEWPStaticData = gql`
    mutation getEWPStaticData($PartnerErasmusCode: String!, $clientHeiEC: String!) {
        getEWPStaticData(PartnerErasmusCode: $PartnerErasmusCode, clientHeiEC: $clientHeiEC) {
            Success
            Message
            StaticData {
                stuNomAutumnTerm
                stuNomSpringTerm
                appNomAutumnTerm
                appNomSpringTerm
                appProcedureEmail
                appProcedurePhone
                appProcedureWebsite
                addReqWeeks 
                ToRWeeks
                additionalRequirements {
                    id
                    requirement
                    details
                    website
                }
                inclusionInfrastructure {
                    id
                    name
                    specialNeeds
                    description
                    email
                    phone
                    website
                }
                inclusionService {
                    id
                    name
                    specialNeeds
                    description
                    email
                    phone
                    website
                }
                housing_email
                housing_phone
                housing_website
                visa_email
                visa_phone
                visa_website
                insurance_email
                insurance_phone
                insurance_website
                additionalInformation {
                    id
                    information
                    email
                    phone
                    website
                }
            }
        }
    }
`;

const mutationSaveCalendarIfNotExists = gql`
	mutation saveCalendarIfNotExists($ErasmusCode: String!){
		saveCalendarIfNotExists(ErasmusCode: $ErasmusCode){
			Success
	  }
	}
`;

const mutationSaveHVIIfNotExists = gql`
	mutation saveHVIIfNotExists($ErasmusCode: String!){
		saveHVIIfNotExists(ErasmusCode: $ErasmusCode){
			Success
	  }
	}
`;

const listOU = gql`
    mutation listOU($ErasmusCodeIn: String!) {
        listOU(ErasmusCodeIn: $ErasmusCodeIn) {
            ounit_id
            institution_ecode
            abbreviation
            is_ewp_partner
            active
            lang
            name
        }
    }
`;

const getEWPOUnits = gql`
    mutation getEWPOUnits($ErasmusCode: String!, $clientHeiEC: String!) {
        getEWPOUnits(ErasmusCode: $ErasmusCode, clientHeiEC: $clientHeiEC) {
            Success
            OUList {
                ounit_id
                name
                institution_ecode
                active
            }
        }
    }
`;

const isIIAManagedByEWP = gql`
    mutation isIIAManagedByEWP($ErasmusCode: String!) {
        isIIAManagedByEWP(ErasmusCode: $ErasmusCode) {
            Success
            Message
        }
    }
`;

const getEWPInstitutionData = gql`
    mutation getEWPInstitutionData($CreatorErasmusCode: String!, $PartnerErasmusCode: String!) {
        getEWPInstitutionData(CreatorErasmusCode: $CreatorErasmusCode, PartnerErasmusCode: $PartnerErasmusCode) {
            Success
            Message
            ContactName
            ContactEmail
            ContactPhone
            WebsiteGeneral
            WebsiteFaculty
            WebsiteCourse
            OUList {
                ounit_id
                name
                institution_ecode
                active
            }
        }
    }
`;

const getInstitutionData = gql`
    mutation getInstitutionData($erasmusCode: String!) {
        getIIAmInstitution(erasmusCode: $erasmusCode) {
            NameInLatinCharacterSet
            HeiID
            ErasmusCode
            CountryName
            CountryISO
            CityName
            PostalCode
        }
    }
`;

const getEWPInstitutionsList = gql`
    mutation getEWPInstitutionsList($CreatorErasmusCode: String!) {
        getEWPInstitutionsList(CreatorErasmusCode: $CreatorErasmusCode) {
            Success
            Message
            InstList {
                SCHAC
                ECODE
            }
        }
    }
`;

const checkPartnerEC = gqlM`
    mutation checkPartnerEC($ErasmusCode: String!) {
        checkPartnerEC(ErasmusCode: $ErasmusCode) {
            ErasmusCode
        }
    }
`;

export default compose(
    graphql(getIIADefaultData, {
        name: "partnerDefaultData",
        options: (props) => {
            const partners = JSON.parse(localStorage.getItem("partnersDetails"));

            return {
                variables: {
                    ErasmusCode: partners.partnerErasmusCode,
                    isToCreate: false
                }
            }
        }
    }),
    graphql(getEWPStaticData, { name: "getEWPStaticData" }),
    graphql(listOU, { name: "listOU" }),
    graphql(getEWPOUnits, { name: "getEWPOUnits" }),
    graphql(isIIAManagedByEWP, { name: "isIIAManagedByEWP" }),
    graphql(getEWPInstitutionData, { name: "getEWPInstitutionData" }),
    graphql(mutationSaveCalendarIfNotExists, { name: 'SaveCalendarIfNotExists' }),
    graphql(mutationSaveHVIIfNotExists, { name: 'SaveHVIIfNotExists' }),
    graphql(getInstitutionData, { name: "getInstitutionData" }),
    graphql(getEWPInstitutionsList, { name: "getEWPInstitutionsList" }),
    graphql(checkPartnerEC, { name: "checkPartnerEC" })
)(Partner);